import { adminHttpClient } from '../../commons/adminHttpClient'

const get1095Report = (planPeriodId: string): Promise<any> => {
  return adminHttpClient.get(`/Reports/1095/${planPeriodId}`)
}

export default get1095Report
